var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn dashboard-manager" },
    [
      _c("ScrollTop"),
      _vm._v(" "),
      _c("SearchSession", { attrs: { onSearchText: _vm.onSearchText } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "client-card-container" },
        [
          _vm.isLoading
            ? _c("div", { staticClass: "isLoading" }, [
                _c(
                  "div",
                  { staticClass: "spinner-align" },
                  [
                    _c("Icon", {
                      staticClass: "icon-size",
                      attrs: { name: "spinner", scale: "5", pulse: "" }
                    })
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.isLoading
            ? _c("ClientCardsManagement", {
                attrs: { clients: _vm.clients, listEM: _vm.listEM }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("p", { staticClass: "total-text" }, [
            _vm._v(_vm._s(_vm.totalRows) + " Clients")
          ]),
          _vm._v(" "),
          _c("b-pagination", {
            attrs: {
              "total-rows": _vm.totalRows,
              "per-page": _vm.itemsPerPage,
              pills: "",
              "first-number": true,
              "last-number": true
            },
            on: { change: _vm.onChangePagination },
            model: {
              value: _vm.currentPage,
              callback: function($$v) {
                _vm.currentPage = $$v
              },
              expression: "currentPage"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-38d9fc4a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38d9fc4a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/manager/DashboardManager.vue
// module id = 1737
// module chunks = 1